import React, { useCallback, useEffect, useState, useRef, forwardRef, useImperativeHandle } from "react";
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import s from './SpeakingAnswers.module.css';
import { useNavigate } from "react-router-dom";
import plusPng from'../asset/plus.png';
import {SoundPlayer} from'./Utilities/SoundPlayer';
import {RedButton, GreenButton, BlueButton} from './MyButton';
import {MyTextarea} from '../components/Utilities/MyTextarea';
import {MyInput} from './Utilities/MyInput';
import MyTooltip from '../components/Utilities/MyTooltip';
import unlockedPng from'../asset/unlocked.png';
import lockPng from'../asset/lock.png';
import studentPng from'../asset/student.png';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import MyComponentLoading from '../components/Utilities/MyComponentLoading';




export default function SpeakingAnswers(prop) {	
	const navigate = useNavigate();
	
	let itemId = prop.itemId;
		
	const [canUpdate, setCanUpdate] = useState(false);	
	const [showReordering, setShowReordering] = useState(false);
	const childRefs = [useRef(), useRef(), useRef()];
	
	const saveAll = async () => {
		childRefs.forEach(ref => {
			setCanUpdate(false);
      if (ref.current) {
        ref.current.saveAll(); // Call the child function
      }
			
    });
	}
	
	
	const saveAllAndResetStudentType = async () => {
		childRefs.forEach(ref => {
			setCanUpdate(false);
      if (ref.current) {
        ref.current.saveAll(); // Call the child function
      }
			
    });
		
		let obj = {
			itemId
		}
		setFetchCompleted(false);
		await postData("speakingApi/resetStudentType", obj, navigate); 
		fetchData();
	}
	
	
	
	const batchLoadMp3AndTranslate = async () => {
		childRefs.forEach(ref => {
      if (ref.current) {
        ref.current.batchLoadMp3AndTranslate(); // Call the child function
      }
			
			setCanUpdate(false);
    });	
	}
	
	
	const [fetchCompleted, setFetchCompleted] = useState(false);	
	const [isDiscussionEnable, setIsDiscussionEnable] = useState(0);	
	const toggleIsDiscussionEnable = async () => {
		let tmp = (isDiscussionEnable == 1) ? 0: 1;
		setIsDiscussionEnable(tmp)
		
		let obj = {
			itemId, isDiscussionEnable: tmp
		}
		
		postData("item/updateIsDiscussionEnable", obj, navigate); 
		
	}
	
	const fetchData = async () => {
		getData('item/getIsDiscussionEnabled?itemId=' + itemId, navigate)
		.then(res => {
				setIsDiscussionEnable(res.data.isDiscussionEnable)
				setFetchCompleted(true);
			}
		);
	}
	
	useEffect(() => {
		fetchData();
	}, []);
	return (<div style={{textAlign:"left", margin:"0 20px"}}>
		<div style={{display:"flex", alignItems:"center", gap:"10px", background:"#bee2fd", borderRadius:"4px", padding:"5px",borderBottom:"4px solid #b2cef7", marginBottom:"5px"}}>
			
			<MyTooltip msg={"&lt;page&gt;" +
											"item.js<br/><br/>" +
											"&lt;components&gt;<br/>" +
											"Book.js<br/>" +
											"SpeakingAnswers.js<br/>"} /> 

				<div style={{cursor:"pointer", display:"flex", alignItems:"center", background:"#486db5", color:"white", padding:"4px", borderRadius:"5px", userSelect: "none", borderBottom:"3px solid #4452af", fontWeight:"bold"}} onClick={()=>{
					setShowReordering(p => !p)
				}}>
				{(showReordering) && (<img style={{width:"30px", height:"30px", background:"white", borderRadius:"15px", margin:"2px", padding:"4px"}} src={unlockedPng} />)}
				{(!showReordering) && (<img style={{width:"30px", height:"30px", background:"white", borderRadius:"15px", margin:"2px", padding:"4px"}} src={lockPng} />)}
					Reordering
				</div>
			
				<GreenButton isEnabled={canUpdate} clickedAction={()=>{saveAll()}} bText={"Save"} />
				<BlueButton isEnabled={true} clickedAction={()=>{saveAllAndResetStudentType()}} bText={"Save + reset student type"} />
				<BlueButton isEnabled={true} clickedAction={()=>{batchLoadMp3AndTranslate()}} bText={"Gen mp3/translate all"} />
				{
					(fetchCompleted) && (<div style={{display:"flex", alignItems:"center", gap:"10px", border:"2px solid #8a97bf", borderRadius:"5px", padding:"2px 5px", background:"#f1fbfd", color:"#2a2e38", fontWeight:"bold"}}>
						<div>Discussion is Free:</div>
						<GreenButton isEnabled={(isDiscussionEnable == 1)} clickedAction={toggleIsDiscussionEnable} bText={(isDiscussionEnable == 1) ? "ON" : "OFF"} />
					</div>)
				}
		</div>
		
		
		{(!fetchCompleted) && (<MyComponentLoading />)}
		{
			(fetchCompleted) && (<div>
				<div style={{fontWeight:"bold", fontSize:"22px"}}>Part A</div>
				<PartShowerAdv ref={childRefs[0]}  itemId={itemId} partLabel={'a'} showReordering={showReordering} canUpdate={canUpdate} setCanUpdate={setCanUpdate}/>
				<div style={{fontWeight:"bold", fontSize:"22px"}}>Part B</div>
				<PartShowerAdv ref={childRefs[1]}  itemId={itemId} partLabel={'b'} showReordering={showReordering} canUpdate={canUpdate} setCanUpdate={setCanUpdate}/>
				<div style={{fontWeight:"bold", fontSize:"22px"}}>Part C</div>
				<PartShowerAdv ref={childRefs[2]}  itemId={itemId} partLabel={'c'} showReordering={showReordering} canUpdate={canUpdate} setCanUpdate={setCanUpdate}/>
			</div>)
		}
	</div>);
	
}

/*
const PartShower = ({pLabel, part, setPart, addNew, setCanUpdate, translateHk, deletePart, loadSentenceAudio}) => {
	const [addNum, setAddNum] = useState(10);
	
	
	return (<div>
	
	
	
		{
			part.map((p, indexP) => (<div key={indexP} style={{display:"flex", alignItems:"start"}}>
			
				<div style={{marginTop:"-10px"}}>
					<li className={s.toggleOptionHolder} style={{whiteSpace:"nowrap"}}>
						<ul className={(p.isTopic == 1) ? s.toggleOptionOn : ""} onClick={()=>{
							part[indexP].isTopic = 1;
							setPart([...part])
							setCanUpdate(true);
						}}>Topic</ul>
						<ul className={(p.isTopic == 0) ? s.toggleOptionOn : ""} onClick={()=>{
							part[indexP].isTopic = 0;
							setPart([...part])
							setCanUpdate(true);
						}}>msg</ul>
						<ul className={(p.isTopic == 2) ? s.toggleOptionOn : ""} onClick={()=>{
							part[indexP].isTopic = 2;
							setPart([...part])
							setCanUpdate(true);
						}}>sub-sec</ul>
					</li>
				</div>
				<div>
					<SoundPlayer soundFile={p.soundTrack}/>
				</div>
				<div style={{marginLeft:"20px"}}>
					<GreenButton isEnabled={true} clickedAction={async ()=>{
						loadSentenceAudio(p.id, p.msg, p.part, indexP);
					}} bText={"gen MP3"} />
				</div>
				<input style={{width:"50px", margin:"0 10px"}} className={s.inputBox} type="number" value={p.ordering} 
					onChange={(e)=> {    
						const inputValue = parseInt(e.target.value);

						if (inputValue >= 0) {
							part[indexP].ordering = inputValue;
							setPart([...part])
							setCanUpdate(true);
						}
					}} />
			
				<div style={(p.isTopic==1) ? 
					{minWidth:"500px", maxWidth:"500px", display:"flex"} : 
					{marginLeft:"40px", minWidth:"460px", maxWidth:"460px", display:"flex"}}>

					{
						(p.isTopic == 0) && (<div style={{width:"40px"}}>
							<div style={{marginTop:"10px", width:"10px", height:"10px", background:"black"}}></div>
						</div>)
					}
					
					{
						(p.isTopic == 2) && (<div style={{width:"40px"}}>
							<div style={{marginTop:"10px", width:"10px", height:"10px", background:"white"}}></div>
						</div>)
					}
					<MyTextarea data={p.msg} setData={(e)=>{
						part[indexP].msg = e;
						setPart([...part])
						setCanUpdate(true);
					}} />
						
				</div>
				
				<div style={{marginLeft:"20px"}}>
					<BlueButton isEnabled={true} clickedAction={async ()=>{
						if (p.msg) {
							let hk = await translateHk(p.msg);
							part[indexP].msgHk = hk;
							setPart([...part])
							setCanUpdate(true);
						}
					}} bText={"translate"} />
				</div>
				
				
				<div style={{marginLeft:"20px", minWidth:"500px", maxWidth:"500px"}}>
					
						<MyTextarea data={p.msgHk} setData={(e)=>{
							part[indexP].msgHk = e;
							setPart([...part])
							setCanUpdate(true);
						}} />
						
				</div>
				
				
				<div style={{marginLeft:"20px"}}>
					<RedButton isEnabled={true} clickedAction={()=>deletePart(p.id, pLabel, indexP)} bText={"delete"} />
				</div>
			
			</div>))
		}
		
		<div style={{display:"flex", alignItems:"center"}}>
			<img className={s.addBtn} src={plusPng}  onClick={()=>{
				addNew(pLabel, addNum);
			}}/>
			
			<input style={{width:"50px", margin:"10px"}} className={s.inputBox} type="number" value={addNum} 
				onChange={(e)=> {    
					const inputValue = parseInt(e.target.value);

					if (inputValue > 0) {
						setAddNum(inputValue)
					} else {
						setAddNum(1)					
					}
				}} />
		</div>
	
	</div>)
	
	
}
*/

const PartShowerAdv = forwardRef(({itemId, partLabel, showReordering, canUpdate, setCanUpdate}, ref) => {
	const navigate = useNavigate();
	
	const [fetchCompleted, setFetchCompleted] = useState(false);	
	const [addNum, setAddNum] = useState(1);	
	const [batchPartStr, setBatchPartStr] = useState("");	
	const [part, setPart] = useState([]);
	
	
	const saveAll = async () => {
		let obj = {
			itemId, part, partLabel 
		}
		
		await postData("item/saveSpeakingAnswers", obj, navigate); 
	}
	
	useImperativeHandle(ref, () => ({
    saveAll, batchLoadMp3AndTranslate
  }));
	
	
	const fetchData = async () => {
		getData('item/getSpeakingAnswersPartByItemId?itemId=' + itemId + "&part="+partLabel, navigate)
		.then(res => {
				let data = res.data;
				
				for(let p of data) {
					p.id = p.id.toString();
				}
				
				setPart(data);
				
				setFetchCompleted(true);
			}
		);
	}
	
	const batchCreate = async (partLabel, batchPartStr) => {	
		setFetchCompleted(false);
		let obj = { itemId, partLabel, batchPartStr }
		await postData("speakingApi/batchLoadSpeakingAnswer", obj, navigate); 		
		fetchData();
	}
	
	
	const batchLoadMp3AndTranslate = async () => {
	
		for (let i=0; i<part.length; i++) {
			let p = part[i];
			
			if (p.msg) {
				if (!p.soundTrack) {
					await loadSentenceAudio (p.id, p.msg, part, i);
				}
				if (!p.msgHk) {
					await translateHkAndSet (i, part, p.msg);
				}
			}
		}
		saveAll();
	}
	const loadSentenceAudio = async (id, sentence, part, index) => {
		let obj = { sentence, }
		let res = await postData("utility/getSentenceAudio", obj, navigate); 
		let soundTrack = res.data;
		
		obj = {id, soundTrack}
		
		postData("item/saveSpeakingAnswersMp3", obj, navigate); 
		
		part[index].soundTrack = soundTrack;
		setPart([...part]);
		
	}
	
	const translateHk = async (sentence) => {
		let obj = { sentence }
		let s = await postData("utility/translateSentence", obj, navigate); 
		return s.data;
	}
	
	const translateHkAndSet = async (index, part, sentence) => {
		let hk = await translateHk(sentence);

		part[index].msgHk = hk;
		setPart([...part])
	
	}
	
	
	const deletePart = async (id, part, index) => {
		let obj = {
			id
		}
		postData("item/deleteSpeakingAnswer", obj, navigate); 		
		part.splice(index, 1);
		setPart([...part]);
	}
	
	const addNew = async (partLabel, addNum) => {
		let obj = {
			itemId, part:partLabel
		}
		
		let newObjs=[];
		for (let i=0; i<addNum; i++) {
			let res = await postData("item/addSpeakingAnswers", obj, navigate); 
			
			let newObj = {
				id:res.data.id.toString(),
				ordering:res.data.ordering,
				itemId,
				part:partLabel,
				isTopic:res.data.isTopic,
				msg:"",
				msgHk:"",
				softDeleted:0,
			}
			newObjs.push(newObj);
		}
		
		setPart([...part, ...newObjs]);
	}
	
	const updateOrdering = async (newPart) => {

		let obj = { itemId, part:newPart }
		postData("speakingApi/reorderKeySpeakingAnswer", obj, navigate); 
	}
	
	//---------------------------------
	const updateStudentType = async (id, studentType) => {

		let obj = { id, studentType }
		postData("speakingApi/updateStudentType", obj, navigate); 
	}
	
	
	const onDragEnd = async (result) => {
    if (!result.destination) return;
		let dId = result.source.droppableId;
		let newPart = Array.from(part);

    const [removed] = newPart.splice(result.source.index, 1);
    newPart.splice(result.destination.index, 0, removed);
		setPart(newPart);
		updateOrdering(newPart);
  };
	
	useEffect(() => {
		fetchData();
	}, []);
	
	if (!fetchCompleted) {
		return (<MyComponentLoading />)
	}
	
	return (<div>
	
				
				<DragDropContext onDragEnd={onDragEnd}>
					<Droppable droppableId={partLabel}>
						{(provided) => (
							<div {...provided.droppableProps} ref={provided.innerRef} 
								style={{display:"flex", flexDirection:"column", gap:"2px", flexWrap: "wrap", alignItems:"start"}}>
	
	
		{
			part.map((p, indexP) => (
			
									<Draggable key={p.id} draggableId={p.id} index={indexP} isDragDisabled={!showReordering}>
										{(provided) => (
											<div
												{...provided.draggableProps}
												{...provided.dragHandleProps}
												ref={provided.innerRef}>
			
			<div key={indexP} style={{display:"flex", alignItems:"start", justifyContent:"start",gap:"5px"}}>
			
				<div>{/*JSON.stringify(p)*/}</div>
				<div style={{marginTop:"-10px"}}>
					<li className={s.toggleOptionHolder} style={{whiteSpace:"nowrap"}}>
						<ul className={(p.isTopic == 1) ? s.toggleOptionOn : ""} onClick={()=>{
							part[indexP].isTopic = 1;
							setPart([...part])
							setCanUpdate(true);
						}}>Topic</ul>
						<ul className={(p.isTopic == 0) ? s.toggleOptionOn : ""} onClick={()=>{
							part[indexP].isTopic = 0;
							setPart([...part])
							setCanUpdate(true);
						}}>msg</ul>
						<ul className={(p.isTopic == 2) ? s.toggleOptionOn : ""} onClick={()=>{
							part[indexP].isTopic = 2;
							setPart([...part])
							setCanUpdate(true);
						}}>sub-sec</ul>
					</li>
				</div>
				<div style={{width:"40px"}}>
					<SoundPlayer soundFile={p.soundTrack}/>
				</div>
				<div>
					<GreenButton isEnabled={true} clickedAction={async ()=>{
						loadSentenceAudio(p.id, p.msg, part, indexP);
					}} bText={"gen MP3"} />
					{
						(p.isTopic == 0 && partLabel == 'a') && (<div style={{display:"flex", alignItems:"center", gap:"2px"}}>
							<img className={s.addBtn} style={{height:"20px", width:"22px"}} src={studentPng} />:
						
							<select className={s.selector} value={p.studentType} onChange={(e)=>{
									let tmpST = e.target.value
									updateStudentType(p.id, tmpST)
									part[indexP].studentType = tmpST;
									setPart([...part])
								}}>
                <option value="" disabled>Select an option</option>
                <option value="a">A</option>
                <option value="b">B</option>
                <option value="c">C</option>
                <option value="d">D</option>
							</select>
						
						
						</div>)
					}
				</div>
				
				{/*
				<input style={{width:"50px", margin:"0 10px"}} className={s.inputBox} type="number" value={p.ordering} 
					onChange={(e)=> {    
						const inputValue = parseInt(e.target.value);

						if (inputValue >= 0) {
							part[indexP].ordering = inputValue;
							setPart([...part])
							setCanUpdate(true);
						}
					}} />
					
										*/}
			
				<div style={(p.isTopic==1) ? 
					{minWidth:"500px", maxWidth:"500px", display:"flex"} : 
					{marginLeft:"40px", minWidth:"460px", maxWidth:"460px", display:"flex"}}>

					{
						(p.isTopic == 0) && (<div style={{width:"40px"}}>
							<div style={{marginTop:"10px", width:"10px", height:"10px", background:"black"}}></div>
						</div>)
					}
					
					{
						(p.isTopic == 2) && (<div style={{width:"40px"}}>
							<div style={{marginTop:"10px", width:"10px", height:"10px", background:"white"}}></div>
						</div>)
					}
					<MyTextarea data={p.msg} maxScrollHeight={"100"} setData={(e)=>{
						part[indexP].msg = e;
						setPart([...part])
						setCanUpdate(true);
					}} />
						
				</div>
				
				<div style={{marginLeft:"20px"}}>
					<BlueButton isEnabled={true} clickedAction={async ()=>{
						if (p.msg) {
							let hk = await translateHk(p.msg);
							part[indexP].msgHk = hk;
							setPart([...part])
							setCanUpdate(true);
						}
					}} bText={"translate"} />
				</div>
				
				
				<div style={{marginLeft:"20px", minWidth:"500px", maxWidth:"500px"}}>
					
						<MyTextarea data={p.msgHk} maxScrollHeight={"100"} setData={(e)=>{
							part[indexP].msgHk = e;
							setPart([...part])
							setCanUpdate(true);
						}} />
						
				</div>
				
				
				<div style={{marginLeft:"20px"}}>
					<RedButton isEnabled={true} clickedAction={()=>deletePart(p.id, part, indexP)} bText={"delete"} />
				</div>
			
			</div>
			
			
			
											</div>
										)}
									</Draggable>
								))}
								
								
								
								{provided.placeholder}
							</div>
						)}
					</Droppable>
				</DragDropContext>
				
				{
					(part.length != 0) && (<div style={{display:"flex", alignItems:"center"}}>
						<img className={s.addBtn} src={plusPng}  onClick={()=>{
							addNew(partLabel, addNum);
						}}/>
						
						<input style={{width:"50px", margin:"10px"}} className={s.inputBox} type="number" value={addNum} 
							onChange={(e)=> {    
								const inputValue = parseInt(e.target.value);

								if (inputValue > 0) {
									setAddNum(inputValue)
								} else {
									setAddNum(1)					
								}
							}} />
					</div>)
				}
				
				{
					(part.length == 0) && (<div style={{display:"flex", flexDirection:"column", gap:"5px"}}>
						<div>batch input, break sentence by linebreak</div>
						<textarea rows="5" wrap="off" className={s.inputArea} value={batchPartStr}
							onChange={(e)=> { 
								setBatchPartStr(e.target.value);
							}} />
							
						<div>
							<GreenButton isEnabled={true} clickedAction={()=>batchCreate(partLabel, batchPartStr)} bText={"batch create"} />
						</div>
					</div>)					
				}
	</div>)
	
	
});

